<form class="panel" (ngSubmit)="onSubmit()" [hidden]="hidden()" data-testid="wcg-create-entity-panel-facility">
    @if ($referenceDataError()) {
        <p class="field__error" data-testid="wcg-create-entity-facility-reference-data-error">Unable to load countries. Please refresh and try again.</p>
    }
    <h3 class="panel__section-title">Facility Details</h3>
    <div class="field">
        <label class="field__label" for="wcg-facility-name">Facility Name<span class="field__required">*</span></label>
        <input id="wcg-facility-name" class="field__input" type="text" placeholder="Enter name" [formField]="$form.name" data-testid="wcg-create-entity-facility-name" />
        @if ($form.name().invalid() && $form.name().touched()) {
            <span class="field__error">Facility name is required.</span>
        }
    </div>
    <div class="field field--half">
        <label class="field__label" id="wcg-facility-type-label">Facility Type<span class="field__required">*</span></label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
                aria-labelledby="wcg-facility-type-label"
                placeholder="Select facility type"
                [formField]="$form.type"
                data-testid="wcg-create-entity-facility-type"
            >
                @for (type of facilityTypes; track type) {
                    <mat-option [value]="type">{{ type }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if ($form.type().invalid() && $form.type().touched()) {
            <span class="field__error">Facility type is required.</span>
        }
    </div>

    <h3 class="panel__section-title">Address Details</h3>
    <div class="field">
        <label class="field__label" for="wcg-facility-address">Address 1<span class="field__required">*</span></label>
        <input id="wcg-facility-address" class="field__input" type="text" placeholder="Enter street address" [formField]="$form.addressLine1" data-testid="wcg-create-entity-address" />
        @if ($form.addressLine1().invalid() && $form.addressLine1().touched()) {
            <span class="field__error">Address is required.</span>
        }
    </div>
    <div class="field-row">
        <div class="field">
            <label class="field__label" for="wcg-facility-city">City<span class="field__required">*</span></label>
            <input id="wcg-facility-city" class="field__input" type="text" placeholder="Enter your city" [formField]="$form.city" data-testid="wcg-create-entity-city" />
            @if ($form.city().invalid() && $form.city().touched()) {
                <span class="field__error">City is required.</span>
            }
        </div>
        <div class="field">
            <label class="field__label" id="wcg-facility-state-label" for="wcg-facility-state">State/province<span class="field__required">*</span></label>
            @if ($states().length > 0) {
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select
                        id="wcg-facility-state"
                        aria-labelledby="wcg-facility-state-label"
                        placeholder="Choose a state/province"
                        [formField]="$form.state"
                        data-testid="wcg-create-entity-state"
                    >
                        @for (state of $states(); track state) {
                            <mat-option [value]="state">{{ state }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <input id="wcg-facility-state" class="field__input" type="text" placeholder="Enter state" [formField]="$form.state" data-testid="wcg-create-entity-state" />
            }
            @if ($form.state().invalid() && $form.state().touched()) {
                <span class="field__error">State is required.</span>
            }
        </div>
    </div>
    <div class="field-row">
        <div class="field">
            <label class="field__label" for="wcg-facility-zip">Zip Code<span class="field__required">*</span></label>
            <input id="wcg-facility-zip" class="field__input" type="text" placeholder="Enter your zip code" [formField]="$form.zipCode" data-testid="wcg-create-entity-zip" />
            @if ($form.zipCode().invalid() && $form.zipCode().touched()) {
                <span class="field__error">Zip code is required.</span>
            }
        </div>
        <div class="field">
            <label class="field__label" id="wcg-facility-country-label">Country<span class="field__required">*</span></label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select
                    aria-labelledby="wcg-facility-country-label"
                    placeholder="Choose a country"
                    [formField]="$form.country"
                    data-testid="wcg-create-entity-country"
                >
                    @for (country of $countries(); track country.country_key) {
                        <mat-option [value]="country.country_key">{{ country.iso_country }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if ($form.country().invalid() && $form.country().touched()) {
                <span class="field__error">Country is required.</span>
            }
        </div>
    </div>
</form>
